import { RenewVisaPresentCompanyApplicationPage } from "@/features/renew-visa/pages/RenewVisaPresentCompanyApplication";

const RenewVisaPresentCompanyApplication = () => {
  return <RenewVisaPresentCompanyApplicationPage />;
};

export default RenewVisaPresentCompanyApplication;
